import styled from "styled-components";

export const SshURLList = styled.div`
  grid-column: auto;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WorkerInfoRow = styled.div`
  display: flex;
  min-height: 41px;
  width: 100%;
  gap: 64px;
  flex-wrap: wrap;

  @media (max-width: 1055px) {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 10px;
    height: 100%;
    width: 100%;
    & > ${SshURLList} {
      grid-column: 1 / span 2;
    }
  }
`;
